import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";
import { tabularNumsClass } from "../../tokens/typography";

const text = cva("text-text", {
  variants: {
    size: {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl",
    },
    variant: {
      body: "font-normal",
      muted: "font-normal text-text-muted",
      // Financial figures (currency, interest rate, tenure) must never
      // proportion-shift digit widths — this is a correctness requirement,
      // not styling preference.
      figure: cn("font-medium", tabularNumsClass),
    },
  },
  defaultVariants: { size: "base", variant: "body" },
});

type TextOwnProps = VariantProps<typeof text> & {
  as?: React.ElementType;
  className?: string;
  children?: React.ReactNode;
};

type TextProps = TextOwnProps & Omit<React.HTMLAttributes<HTMLElement>, keyof TextOwnProps>;

export function Text({ as: Component = "p", size, variant, className = "", ...props }: TextProps) {
  return <Component className={cn(text({ size, variant }), className)} {...props} />;
}
